import { render, staticRenderFns } from "./position_management.vue?vue&type=template&id=05a90561&"
import script from "./position_management.vue?vue&type=script&lang=js&"
export * from "./position_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a90561')) {
      api.createRecord('05a90561', component.options)
    } else {
      api.reload('05a90561', component.options)
    }
    module.hot.accept("./position_management.vue?vue&type=template&id=05a90561&", function () {
      api.rerender('05a90561', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/data_auth/position_management.vue"
export default component.exports